/**
 * File: aria-list.js
 *
 * Import and initialize functions for zoom accessibility issue
 */

export default {
	pagination: document.querySelector('.navigation.pagination'),
  init() {
		if (this.pagination) {
			this.render();
		}
  },
  render() {
    const pagination = document.querySelector('.navigation.pagination');
    if (!pagination) return;
    // delete h2 tag
    pagination.querySelector('h2.screen-reader-text').remove();

    // change span to link
    const currentPageSpan = pagination.querySelector('.current');
    const currentPageSpanChildren = currentPageSpan.innerHTML;
    currentPageSpan.outerHTML = `<a href="#" class="page-numbers current">${currentPageSpanChildren}</a>`

    // change div to ul
    const navLinksDiv = pagination.querySelector('.nav-links');

    // wrap links to li
    const links = navLinksDiv.querySelectorAll('.page-numbers');

    // li numbers.
    const numbers = pagination.querySelectorAll('.page-numbers:not(.next)');
    const numbersLength = numbers.length;
    const lastNumberText = numbers[numbersLength - 1].text;
    const lastNumber = lastNumberText.split(' ');

    let newLinks = '';
    links.forEach(link => {
      // Set links aria label.
      const text = link.text;
      if (text !== undefined) {
        link.setAttribute('aria-label', text);
      }
      // Set current page.
      if (link.classList.contains('current')) {
        link.setAttribute('aria-current', 'page');
      }
      const classes = link.className;
      link.removeAttribute('class');
      newLinks += `<li class="${classes}">${link.outerHTML}</li>`
    });

    navLinksDiv.outerHTML = `<ul class="nav-links">${newLinks}</ul>`
    const nav = pagination.querySelector(nav);
    pagination.removeAttribute('role');
    pagination.setAttribute('aria-label', 'pagination');
  },
};
